// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"182":"517e70e5","309":"751b83e8","342":"6eb3e91b","484":"517e70e5","784":"517e70e5"}[chunkId] + ".chunk.css";
};